import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSync24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconArrowSync24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13.54 6.221c-3.243-.869-6.234.952-7.116 4.243l-.01.036h2.8a.75.75 0 0 1 0 1.5H4V6.75a.75.75 0 0 1 1.5 0v1.9c1.503-3.15 4.846-4.837 8.429-3.877a7.6 7.6 0 0 1 3.395 1.932.75.75 0 1 1-1.056 1.065 6.1 6.1 0 0 0-2.727-1.549m-3.074 11.562c3.243.87 6.234-.951 7.116-4.243l.01-.036h-2.8a.75.75 0 0 1 0-1.5h5.214v5.25a.75.75 0 0 1-1.5 0v-1.9c-1.503 3.15-4.846 4.838-8.429 3.878a7.6 7.6 0 0 1-3.395-1.933.75.75 0 1 1 1.056-1.065 6.1 6.1 0 0 0 2.728 1.549"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowSync24);
